export default __webpack_public_path__ + "static/iww-website-06df417a146d148f115ac98b7163e393.jpg";